import React from 'react';
import { MDBCol } from 'mdbreact';
import { Field } from 'redux-form';
import InputField from '../../customFields/InputField';
import ProjectAndCompanyField from './projectAndCompanyField';
import ControlElement from '../../../ControlElement';

// --- Validation Helpers ---
const specialCharRegex = /^[a-zA-Z0-9\s-_]+$/;

// Rejects special characters except spaces, dashes, and underscores
const validateNoSpecialChars = (value) => {
    if (!value) return undefined;
    return specialCharRegex.test(value)
        ? undefined
        : 'Special characters are not allowed';
};

const requiredField = (value) =>
    value && value.trim() !== '' ? undefined : 'This field is required';

// --- Component ---
const MarksSection = ({ toggleModal, hideElements = {}, requirements }) => (
    <>
        <div className="fields_group">

            <ControlElement hide={hideElements?.customTagId}>
                <div className="field_col">
                    <label className="field_name" htmlFor="company_wo_id">Company WO ID*</label>
                    <div className="field_block">
                        <Field
                            name="customTagId"
                            component={InputField}
                            type="text"
                            placeholder="Company WO ID"
                            required={requirements !== 'disabled'}
                            maxLength={50}
                            id="company_wo_id"
                            inputClassName="form-control custom-input-style"
                            // validate={
                            //     requirements !== 'disabled'
                            //         ? [requiredField, validateNoSpecialChars]
                            //         : [validateNoSpecialChars]
                            // }
                        />
                    </div>
                </div>
            </ControlElement>

            <div className="field_col">
                <label className="field_name" htmlFor="title">Title</label>
                <div className="field_block">
                    <Field
                        name="title"
                        component={InputField}
                        type="text"
                        placeholder="Title"
                        required={requirements !== 'disabled'}
                        maxLength={50}
                        id="title"
                        inputClassName="form-control custom-input-style"
                        // validate={[validateNoSpecialChars]}
                    />
                </div>
            </div>

            <ProjectAndCompanyField
                name="projectInfo"
                label="Project"
                linkName="projects"
                addButtonLabel="Create Project"
                toggleModal={toggleModal}
                className="font-size-08"
            />

            <ProjectAndCompanyField
                name="woCompanyInfo"
                label="Company"
                linkName="wo-companies"
                addButtonLabel="Add Company"
                toggleModal={toggleModal}
                className="font-size-08"
            />
        </div>
    </>
);

export default MarksSection;
